module.exports = __webpack_public_path__ + "img/cashier07.99cc1c32.png";